import Header from 'components/header/Header';
import React, { useCallback, useEffect } from 'react';
import { IStyle } from 'Styles';
import DispensingPropertiesDefinition from './DispensingPropertiesDefinition';
import { useGeneralDispensingProperties } from 'redux/hooks/generalDispensingProperties';
import { useRMDispatch } from 'redux/hooks';
import { saveGeneralDispensingPropertiesThunk } from 'redux/thunks/GeneralDispensingProperties';
import { transformGeneralDispensingPropertiesToRequest } from 'transformers/generalDispensingProperties';
import { discard } from 'redux/reducers/GeneralDispensingPropertiesReducer';
import { KeyboardKeys } from 'constants/';
import { useSaveDiscardButtons } from 'CustomHooks/useSaveDiscardButtons';

const DispensingPropertiesDashboard = () => {
  const dispatch = useRMDispatch();
  const generalDispensingPropertiesData = useGeneralDispensingProperties();
  const generalDispensingPropertiesToSave =
    generalDispensingPropertiesData.generalDispensingPropertiesToSave;
  const isDirty = generalDispensingPropertiesData.isDirty;

  const onSave = () => {
    dispatch(
      saveGeneralDispensingPropertiesThunk(
        transformGeneralDispensingPropertiesToRequest(generalDispensingPropertiesToSave),
      ),
    );
  };

  const onDiscard = () => {
    dispatch(discard());
  };

  const saveDiscardButtons = useSaveDiscardButtons({
    enableButtons: isDirty,
    onSave: onSave,
    onDiscard: onDiscard,
  });
  const handleUserKeyPress = useCallback(
    (e: KeyboardEvent) => {
      const ctrlKey = e.ctrlKey || e.metaKey;

      if (ctrlKey && e.key === KeyboardKeys.S) {
        e.preventDefault();
        if (isDirty) {
          onSave();
        }
      }
    },
    [isDirty, onSave],
  );

  useEffect(() => {
    const abortController = new AbortController();
    const signal = abortController.signal;

    window.addEventListener('keydown', handleUserKeyPress, { signal });

    return () => {
      abortController.abort();
    };
  }, [handleUserKeyPress]);

  return (
    <div id="index-dispensingpropertiesdashboard-wrapper" className="w-full h-full">
      <div id="index-dispensingpropertiesdashboard-container" className="setup-bg-topbar">
        <Header
          headerButtons={saveDiscardButtons}
          isNewTheme={true}
          title={'Dispensing Properties'}
        />
        <div
          id="index-dispensingpropertiesdashboard-plateinfo-container"
          className="bg-white p-[4px]"
          style={styles.plateInfoContainer}
        >
          <div
            id="index-dispensingpropertiesdashboard-plateinfo-definition"
            className="flex gap-[8px] border border-[color:var(--neutral-color-neutral-10,#E0E0E0)] border-solid"
          >
            <DispensingPropertiesDefinition />
            <div
              id="index-dispensingpropertiesdashboard-plateinfo-background"
              className="bg-[#CACACA] w-[1px]"
            ></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DispensingPropertiesDashboard;

const styles: IStyle = {
  plateInfoContainer: {
    width: '91vw',
    height: '81vh',
  },
};
